import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';

import Button from '../../../Common/Button';
// Utils.
import { gaEventIfAllowed } from '../../../../utils/googleAnalytics';

export const ThankYou: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { selectedForm, selectedForm4, createNewContract, payment } = ManageContractsApp.useState();

  return (
    <div className="manage-contracts-thankyou">
      {selectedForm !== 3 && !(selectedForm === 4 && selectedForm4 === 2) && !(selectedForm === 1 && !createNewContract) && (
        <>
          {selectedForm !== 4 && <h1 aria-live="polite">{t(`manageContracts:manageContracts.FinishTitleNew`)}</h1>}
          {selectedForm === 4 && <h1 aria-live="polite">{t(`manageContracts:manageContracts.FinishTitleOption4_1`)}</h1>}

          {selectedForm !== 4 && (
            <p>
              <Trans
                i18nKey={`manageContracts:manageContracts.FinishBody${selectedForm === 3 || (selectedForm === 1 && !createNewContract) ? 'End' : ''}`}
                values={{
                  teamLink1: t(`manageContracts:manageContracts.FinishBodyTeamLink1`),
                  teamLink2: t(`manageContracts:manageContracts.FinishBodyTeamLink2`),
                }}
              >
                . <a href="https://tiimi.lumme-energia.fi/" target="_blank" rel="noopener noreferrer"></a>
              </Trans>
            </p>
          )}
          {selectedForm === 4 && selectedForm4 === 1 && (
            <p>
              <Trans
                i18nKey={`manageContracts:manageContracts.FinishBodyOption4_1`}
                values={{
                  teamLink1: t(`manageContracts:manageContracts.FinishBodyTeamLink1`),
                  teamLink2: t(`manageContracts:manageContracts.FinishBodyTeamLink2`),
                }}
              >
                . <a href="https://tiimi.lumme-energia.fi/" target="_blank" rel="noopener noreferrer"></a>
              </Trans>
            </p>
          )}
          {selectedForm === 4 && selectedForm4 === 3 && (
            <p>
              <Trans
                i18nKey={`manageContracts:manageContracts.FinishBodyOption4_3`}
                values={{
                  teamLink1: t(`manageContracts:manageContracts.FinishBodyTeamLink1`),
                  teamLink2: t(`manageContracts:manageContracts.FinishBodyTeamLink2`),
                }}
              >
                . <a href="https://tiimi.lumme-energia.fi/" target="_blank" rel="noopener noreferrer"></a>
              </Trans>
            </p>
          )}
          <Button
            type="button"
            link="https://fbly.io/l/e55ppo"
            newTab
            onClick={(): void => {
              gaEventIfAllowed({
                category: 'Hallinnoi sopimuksia - Anna palautetta',
                action: 'Hallinnoi sopimuksia - Anna palautetta',
              });
            }}
          >
            {t('manageContracts:manageContracts.FinishBodyFeedbackButton')}
          </Button>
        </>
      )}
      {(selectedForm === 3 || (selectedForm === 1 && !createNewContract)) && (
        <>
          <h1 aria-live="polite">{t(`manageContracts:manageContracts.FinishTitleEnd`)}</h1>
          <p>{t(`manageContracts:manageContracts.FinishBodyEnd`)}</p>
        </>
      )}
      {selectedForm === 4 && selectedForm4 === 2 && (
        <>
          <h1 aria-live="polite">
            {t(`manageContracts:manageContracts.FinishTitleOption4_2_${payment.paymentType === 'eBill' ? 'Ebill' : 'Email'}`)}
          </h1>
          <p>{t('manageContracts:manageContracts.FinishBody4Bill1')}</p>
          {payment.paymentType === 'eBill' && (
            <p>
              <Trans
                i18nKey="manageContracts:manageContracts.FinishBody4BillEbill"
                values={{ bolded: t(`manageContracts:manageContracts.FinishBody4BillEbillBolded`) }}
              >
                . <strong></strong>
              </Trans>
            </p>
          )}
          <p>{t('manageContracts:manageContracts.FinishBody4Bill2')}</p>
        </>
      )}
    </div>
  );
};

export default ThankYou;
